import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link as RouterLink, useLocation } from 'react-router-dom';

const PAGE_DEFINITIONS = [
  { match: /^\/search$/, title: 'Recherche', nativeHeader: true },
  { match: /^\/(?:dashboard)?$/, title: 'Tableau de bord', description: "Vue d’ensemble de l’activité du bureau d’études" },
  { match: /^\/affaires$/, title: 'Affaires', nativeHeader: true },
  { match: /^\/prospection\/?$/, title: 'Prospection', nativeHeader: true },
  { match: /^\/affaires\/[^/]+$/, title: 'Détail de l’affaire', parent: ['Affaires', '/affaires'], nativeHeader: true },
  { match: /^\/projets$/, title: 'Projets', nativeHeader: true },
  { match: /^\/projets\/[^/]+\/lda$/, title: 'Liste des activités', parent: ['Projets', '/projets'], nativeHeader: true },
  { match: /^\/projets\/[^/]+\/devis$/, title: 'Devis du projet', parent: ['Projets', '/projets'], nativeHeader: true },
  { match: /^\/projets\/[^/]+\/bilan-puissance$/, title: 'Bilan de puissance', parent: ['Projets', '/projets'], nativeHeader: true },
  { match: /^\/projets\/[^/]+$/, title: 'Détail du projet', parent: ['Projets', '/projets'], nativeHeader: true },
  { match: /^\/interventions\/creation$/, title: 'Nouvelle intervention', parent: ['Interventions', '/interventions'], nativeHeader: true },
  { match: /^\/interventions\/[^/]+$/, title: 'Détail de l’intervention', parent: ['Interventions', '/interventions'], nativeHeader: true },
  { match: /^\/interventions$/, title: 'Interventions', nativeHeader: true },
  { match: /^\/devis$/, title: 'Devis', nativeHeader: true },
  { match: /^\/partenaires\/creation$/, title: 'Nouveau partenaire', parent: ['Partenaires', '/partenaires'], nativeHeader: true },
  { match: /^\/partenaires\/[^/]+$/, title: 'Détail du partenaire', parent: ['Partenaires', '/partenaires'], nativeHeader: true },
  { match: /^\/partenaires$/, title: 'Partenaires', nativeHeader: true },
  { match: /^\/planning$/, title: 'Planning', nativeHeader: true },
  { match: /^\/ged$/, title: 'Gestion documentaire', nativeHeader: true },
  { match: /^\/wiki/, title: 'Wiki', nativeHeader: true },
  { match: /^\/rh\/documents\/demo$/, title: 'Modèles de documents', parent: ['Mon espace', '/rh'], nativeHeader: true },
  { match: /^\/rh$/, title: 'Mon espace', nativeHeader: true },
  { match: /^\/stock$/, title: 'Stock', parent: ['Administratif', '/administratif'], nativeHeader: true },
  { match: /^\/tasks$/, title: 'Tâches', nativeHeader: true },
  { match: /^\/administratif\/competences$/, title: 'Compétences', parent: ['Administratif', '/administratif'], nativeHeader: true },
  { match: /^\/administratif\/utilisateurs$/, title: 'Utilisateurs', parent: ['Administratif', '/administratif'], nativeHeader: true },
  { match: /^\/administratif\/couts-horaires$/, title: 'Coûts horaires', parent: ['Administratif', '/administratif'], nativeHeader: true },
  { match: /^\/administratif\/notes-de-frais$/, title: 'Note de frais', parent: ['Administratif', '/administratif'], nativeHeader: true },
  { match: /^\/administratif\/suivi-erp(?:\/.*)?$/, title: 'Suivi ERP', parent: ['Administratif', '/administratif'], nativeHeader: true },
  { match: /^\/administratif$/,  title: 'Administratif', nativeHeader: true },
  { match: /^\/temps/, title: 'Suivi des temps', nativeHeader: true },
  { match: /^\/saisietemps/, title: 'Suivi des temps', nativeHeader: true },
];

function PageHeader({ actions }) {
  const { pathname } = useLocation();
  const page = PAGE_DEFINITIONS.find(({ match }) => match.test(pathname));

  if (!page || /^\/(?:ged|dashboard)?\/?$/.test(pathname)) return null;

  const breadcrumbs = (
    <nav className="erp-breadcrumbs" aria-label="Fil d’Ariane">
      <RouterLink to="/dashboard">Accueil</RouterLink>
      {page.parent && (
        <>
          <ChevronRightIcon aria-hidden="true" />
          <RouterLink to={page.parent[1]}>{page.parent[0]}</RouterLink>
        </>
      )}
      <ChevronRightIcon aria-hidden="true" />
      <span aria-current="page">{page.title}</span>
    </nav>
  );

  if (page.nativeHeader) {
    return <div className="erp-page-header erp-page-header--breadcrumbs-only">{breadcrumbs}</div>;
  }

  return (
    <header className="erp-page-header">
      {breadcrumbs}
      <div className="erp-page-header__row">
        <div>
          <h1>{page.title}</h1>
          <p>{page.description}</p>
        </div>
        {actions && <div className="erp-page-header__actions">{actions}</div>}
      </div>
    </header>
  );
}

export default PageHeader;
